<template>
    <div class="wrap-input" :class="customClass">
        <label class="label"
            :class="{'error': !isFirstSave && isShowErrorLbl && !errorInfo.isValid}"
            :for="id">{{label}}</label>
        <div :class="{'error': !isFirstSave && isShowErrorLbl && !errorInfo.isValid}">
            <b-dropdown :text="textValueDropdown" no-caret
                class="province-ddl-input"
                :class="{'error': !isFirstSave && isShowErrorLbl && !errorInfo.isValid}"
                :id="id"
                v-model="content"
                variant="ddl-input"
                menu-class="ddl-menu">
            <b-dropdown-item v-for="value in arrProvince"
                :key="value.province_code"
                @click="onChange(value)">
                {{value.province_name}}
            </b-dropdown-item>
            </b-dropdown>
            <div class="error-text"
                v-if="isShowErrorLbl"
                v-show="!isFirstSave && !errorInfo.isValid">{{errorInfo.msg}}
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import BzbsAddress from '@/core/Address/service/BzbsAddress.js';
// import Util from "@/helper/Utility.js";
/**
 * Property
 * @property {string} inputId (required) Field id for emit.
 * @property {object} inputLbl (required) Text for component.
 * @property {number} inputMinLength (optional) Minimum length.
 * @property {number} inputMaxLength (optional) Maximum Length.
 * @property {boolean} isFirstSave (required) Show/Hide Error after save.
 * @property {boolean} isShowErrorLbl (optional) Show/Hide Error label.
 * @property {object} errorInfo (required) Validation status. example : { isValid: true, msg: '',}
 * @property {boolean} blockAutoComplete (optional) Block borwser auto complete field.
 * @property {string} addClass (optional) Add css class
 * Event
 * @event onChange Filter and validate.
 * Method
 * @method validateInput Validate text.
 */
export default {
    name: "Province",
    props: {
        //v-model
        value: Object,
        //props
        inputId: String,
        inputLbl: Object,
        inputMinLength: Number,
        inputMaxLength: Number,
        isFirstSave: Boolean,
        isShowErrorLbl: Boolean,
        errorInfo: Object,
        blockAutoComplete: Boolean,
        addClass: String,
    },
    data: function() {
        return {
            id: '',
            label: '',
            content: this.value,
            minLength: 0,
            maxLength: 0,
            readOnly: true,
            customClass: '',
            textValueDropdown: '',

            arrProvince: [],
        };
    },
    created: function() {
        this.id = this.inputId;
        this.label = this.inputLbl.name;
        this.minLength = this.inputMinLength || null;
        this.maxLength = this.inputMaxLength || null;
        this.customClass = this.addClass || '';
        this.validateInput();
        this.getProvince();

        this.dropdownList = this.itemList;
        if(this.value) {
            this.textValueDropdown = this.value;
        } else {
            this.textValueDropdown = this.inputLbl.required;
        }

        this.readOnly = this.blockAutoComplete;
        setTimeout(() => {
            this.readOnly = false;
        }, 500);
    },
    mounted: function() {
        
    },
    methods: {
        validateInput: function (setContent) {
            if(!this.inputLbl) return;
            //Set default.
  
            this.errorInfo.isValid = true;
            this.errorInfo.msg = '';

            //Required
            if(this.inputLbl.required && !setContent) {
                console.log('invalid povince')
                this.errorInfo.isValid = false;
                this.errorInfo.msg = this.inputLbl.required;
                return;
            }
            //InValid format
            if(this.inputLbl.invalid) {
                if(!Vue.validator.validateZipCode(setContent)) {

                    this.errorInfo.isValid = false;
                    this.errorInfo.msg = this.inputLbl.invalid;
                    return;
                }
            }
        },
        onChange: function(content) {
            this.textValueDropdown = content.province_name
            let setContent = content
            this.validateInput(setContent);
            this.$emit('input', content);
        },
        getProvince: function() {
            BzbsAddress.apiGetProvince().then(response => {
                if(this.arrProvince.length === 0) {
                    response.forEach(element => {
                        this.arrProvince.push(element);
                    })
                }
                return this.arrProvince
            });
        }
    },
}
</script>

<style lang="scss" scoped>
.label{
    font-family: "DBHeaventRegular";
    font-size: 1.5rem;
}

::v-deep .btn-ddl-input {
    font-family: "DBHeaventRegular";
    font-size: 1.5rem;
    color: #666666;
    line-height: 1em;
}
::v-deep .error {
    .btn-ddl-input {
        // color: #f00;
        border: 1px solid #f00;
    }
}
.province-ddl-input {
    border: 1px solid #d6d6d6;
    width: 100%;
    background-color: #fff;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='13' height='7' viewBox='0 0 13 7' fill='none'%3E%3Cpath d='M6.5 7a.936.936 0 0 1-.644-.252l-5.59-5.28a.827.827 0 0 1 0-1.216.949.949 0 0 1 1.288 0L6.5 4.924 11.446.252a.949.949 0 0 1 1.287 0 .826.826 0 0 1 0 1.216l-5.59 5.28A.936.936 0 0 1 6.5 7z' fill='%23044437'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-size: 12px;
    background-position-x: calc(100% - 13px);
    background-position-y: 18px;
    height: 45px;
    border-radius: 5px;
    font-family: "DBHeaventRegular";
    &:focus {
        box-shadow: none;
        outline: none;
    }
    &::after {
        display: none;
    }
    &.btn:hover {
        color: #000;
    }
}
select::-ms-expand {
    display: none;
}
.ddl-menu.dropdown-menu {
    color: #000;
    background: #fff;
    max-height: 300px;
    overflow-y: auto;
    width: 100%;
}
</style>